<template>
  <el-dialog
    :visible.sync="showModal"
    :append-to-body="true"
    class="promo-offer-modal"
    @close="close"
  >
    <h2 class="promo-offer-modal__title">{{ promoMeta.header }}</h2>
    <div
      v-if="promoData && promoData.success"
      class="promo-offer-modal__description"
    >
      <p>{{ promoMeta.subheader }}</p>
    </div>

    <el-button
      class="promo-offer-modal__explore"
      type="primary"
      @click="signup"
    >
      Sign up now
    </el-button>

  </el-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    promoData: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    showModal: {
      get() {
        return this.show;
      },
      set() {

      },
    },
  },
  methods: {
    close() {
      this.$emit('closePromoOfferModal');
    },
    signup() {
      this.$emit('closePromoOfferModal', true);
    },
  },
};
</script>

<style lang="scss">
@import "../assets/scss/variables.scss";

.promo-offer-modal {
  .el-dialog {
    background-color: $brand;
    border-radius: 7px;
    text-align: center;
    padding: 70px;
    max-width: 680px;
    margin-top: 0 !important;

    display: inline-block;

    width: auto;

    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);

    &__body {
      padding: 0;
    }

    &__header {
      padding: 0;
    }

    @media (max-width: 767px) {
      top: 0;
      left: 0;
      transform: none;

      width: 100%;
      height: 100%;
      border-radius: 0;

      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  &__title {
    font-size: 40px;
    color: $black;

    margin: 0;
  }

  &__description {
    margin: 30px 0 45px;

    > p {
      color: $black;
      font-size: 16px;
    }
  }

  &__explore {
    padding: 14px 30px;
    font-size: 18px;
    background-color: #ffffff;
    border-color: #ffffff;
    color: #111111;
  }
}
</style>



// WEBPACK FOOTER //
// app/src/components/PromoOfferModal.vue